import React from 'react';

// Time-slot list for the selected day. Each slot is an ISO instant; the parent
// supplies a timezone-aware formatter.
const TimeSlots = ({ slots, selected, formatTime, onSelect }) => {
  if (!slots.length) {
    return <p className="preob-cal__noslots">No times available for this date. Please pick another day.</p>;
  }
  return (
    <div className="preob-cal__slots">
      <p className="preob-cal__slots-label">Available times</p>
      <div className="preob-cal__slots-grid">
        {slots.map((iso) => {
          const isSel = iso === selected;
          return (
            <button
              key={iso}
              type="button"
              className={`preob-cal__slot${isSel ? ' preob-cal__slot--selected' : ''}`}
              onClick={() => onSelect(iso)}
              aria-pressed={isSel}
            >
              {formatTime(iso)}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default TimeSlots;
